import { Component, OnInit } from '@angular/core';
import { Modal } from 'bootstrap';
import * as dayjs from 'dayjs';
import { Diet, Meal } from 'src/app/interfaces/diet';
import { RoutineGroup, RoutineModel } from 'src/app/interfaces/routine';
import { User } from 'src/app/interfaces/user';
import { DietService } from 'src/app/services/diet.service';
import { RoutineService } from 'src/app/services/routine.service';
import { StateService } from 'src/app/services/state.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-import-objects-selector',
  templateUrl: './import-objects-selector.component.html',
  styleUrls: ['./import-objects-selector.component.scss'],
})
export class ImportObjectsSelectorComponent implements OnInit {
  user?: User;
  parentObjects?: any;

  objectType?: 'routine' | 'diet';

  selectedRoutineGroup?: RoutineGroup;

  constructor(
    private stateService: StateService,
    private routineService: RoutineService,
    private toastService: ToastService,
    private dietService: DietService
  ) {}

  ngOnInit(): void {
    this.stateService.selectedImportUserData$.subscribe({
      next: (user?: User) => {
        this.stateService.selectedDiet
          ? (this.objectType = 'diet')
          : (this.objectType = 'routine');

        if (user) {
          this.user = user;

          if (this.stateService.selectedRoutineGroup) {
            this.getUserRoutines();
          } else {
            this.getUserDiets();
          }
        }
      },
    });
  }

  getUserDiets() {
    this.dietService.getUserDietHistory(String(this.user!.id)).subscribe({
      next: (response: any) => {
        this.parentObjects = response.diets;

        if (this.parentObjects) {
          this.getMealsFromDiet();
        }

        // const diets = this.parentObjects as Diet[];
      },
    });
  }

  getUserRoutines() {
    this.routineService.getRoutineGroups(String(this.user!.id)).subscribe({
      next: (response: any) => {
        this.parentObjects = response.routineGroups;
      },
    });
  }

  importRoutineModel(routineModel: RoutineModel) {
    this.routineService
      .importRoutineModel(
        this.stateService.selectedRoutineGroup!.id!,
        routineModel.id!
      )
      .subscribe({
        next: () => {
          this.toastService.success('Importamos con éxito la rutina');
          routineModel.imported = true;
        },
      });
  }

  importMeal(meal: Meal) {
    this.dietService
      .importMeal(meal, this.stateService.selectedDiet!.id)
      .subscribe({
        next: () => {
          this.toastService.success('Importamos con éxito la rutina');
          meal.imported = true;
        },
      });
  }

  getMealsFromDiet() {
    this.parentObjects.forEach((d: Diet) => {
      this.dietService.getMealsFromDiet(d.id).subscribe({
        next: (response: any) => {
          d.meals = response.meals;
        },
        error: () => {
          this.toastService.alert(
            'Ha ocurrido un problema encontrando las comidas en la base de datos.'
          );
        },
      });
    });
  }

  closeModal() {
    this.stateService.openModal.hide();

    const modal = new Modal('#importUserSelectorModal');
    this.stateService.openModal = modal;
    modal.show();
  }

  selectGroup(group: RoutineGroup) {
    this.selectedRoutineGroup = group;
  }
}
